var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHaltIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_66_6764",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_66_6764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99961 15C9.53711 15 10.0621 14.9281 10.5746 14.7844C11.0871 14.6406 11.5746 14.4313 12.0371 14.1563L9.13086 11.25H8.99961C8.16211 11.25 7.34961 11.3844 6.56211 11.6531C5.77461 11.9219 5.04961 12.3125 4.38711 12.825C5.01211 13.5125 5.69961 14.0469 6.44961 14.4281C7.19961 14.8094 8.04961 15 8.99961 15ZM15.3559 17.475L13.1434 15.2625C12.5309 15.6625 11.8746 15.9688 11.1746 16.1813C10.4746 16.3938 9.74961 16.5 8.99961 16.5C7.96211 16.5 6.98711 16.3031 6.07461 15.9094C5.16211 15.5156 4.36836 14.9813 3.69336 14.3063C3.01836 13.6313 2.48398 12.8375 2.09023 11.925C1.69648 11.0125 1.49961 10.0375 1.49961 9C1.49961 8.2625 1.60273 7.54375 1.80898 6.84375C2.01523 6.14375 2.31836 5.48125 2.71836 4.85625L0.505859 2.625L1.57461 1.55625L16.4246 16.4063L15.3559 17.475ZM15.2621 13.125L10.9871 8.85C11.1996 8.6125 11.359 8.34688 11.4652 8.05313C11.5715 7.75938 11.6246 7.45 11.6246 7.125C11.6246 6.4 11.3684 5.78125 10.8559 5.26875C10.3434 4.75625 9.72461 4.5 8.99961 4.5C8.67461 4.5 8.36523 4.55313 8.07148 4.65938C7.77773 4.76563 7.51211 4.925 7.27461 5.1375L4.87461 2.7375C5.48711 2.3375 6.14336 2.03125 6.84336 1.81875C7.54336 1.60625 8.26211 1.5 8.99961 1.5C10.0371 1.5 11.0121 1.69688 11.9246 2.09063C12.8371 2.48438 13.6309 3.01875 14.3059 3.69375C14.9809 4.36875 15.5152 5.1625 15.909 6.075C16.3027 6.9875 16.4996 7.9625 16.4996 9C16.4996 9.7375 16.3934 10.4563 16.1809 11.1563C15.9684 11.8563 15.6621 12.5125 15.2621 13.125Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHaltIcon);
export default __webpack_public_path__ + "static/media/haltIcon.f1d22697c56a9acd626a7568fd997f30.svg";
export { ForwardRef as ReactComponent };